require('styles/App.css');
const firebase = require('firebase');
import React from 'react';
import Calendar from './Calendar';
import Content from './Content';

var config = {
  apiKey: "AIzaSyCG1uH3AyDRneozpEx-DWqaop26rDtEJao",
  authDomain: "kinstovic-svatba.firebaseapp.com",
  databaseURL: "https://kinstovic-svatba.firebaseio.com",
  projectId: "kinstovic-svatba",
  storageBucket: "kinstovic-svatba.appspot.com",
  messagingSenderId: "423155957920"
};
if (!firebase.apps.length) firebase.initializeApp(config);


let heading = require('../images/heading.svg');

class AppComponent extends React.Component {
  render() {
    return (
      <div className="index">
        <header>
          <div className="row">
            <h1>Evča a Kuba - 5. 5. 2018</h1>
            <img id="heading" src={heading} alt="Evča a Kuba - 5. 5. 2018"/>
          </div>
        </header>
        <main>
          <Calendar/>
          <Content/>
        </main>
        <footer className="page-footer gold">
          <div className="container">
            <div className="row">
              <div className="col l6 s12">
                <h5 className="white-text">Těšíme se na vaši návštěvu</h5>

              </div>
            </div>
          </div>
          <div className="footer-copyright">
            <div className="container">
              © 2018 Eva Kufnerová a Jakub Kinšt
              <div className="right">
                <a className="grey-text text-lighten-4" href="mailto:jakub@kinst.cz">jakub@kinst.cz</a>&nbsp;
                <span className="grey-text text-lighten-7">/</span>&nbsp;
                <a className="grey-text text-lighten-4" href="mailto:eva@kinst.cz">eva@kinst.cz</a>
              </div>
            </div>
          </div>
        </footer>
      </div>

    )
  }
}

AppComponent.defaultProps = {};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js